import { ReactElement } from "react";
import { IEAFProduction } from "../../../types";
import KeyValueItem from "../../../components/charts/keyValueItem";
import { formatNumber, toTons } from "../../../system/utils";

const HeatDetailInfo = (heatData: IEAFProduction): ReactElement => {
  return(
    <>
      <KeyValueItem name={"Steel"} value={heatData.steel.code}/>
      <KeyValueItem name={"Weight"} value={formatNumber(toTons(heatData.weight), 2)} unit="US ton" />
      <KeyValueItem name={"Power ON"} value={formatNumber(heatData.powerON, 2)} unit="min" />
      <KeyValueItem name={"Power OFF"} value={formatNumber(heatData.powerOFF, 2)} unit="min" />
      <KeyValueItem name={"Tap to Tap"} value={formatNumber(heatData.tapToTap / 60, 2)} unit="min" />
    </>
  );
};

export default HeatDetailInfo;
